import { mockData } from "./Mock";
import { Approval } from "../../models/Approval";

const mockUnprocessedApprovals: Approval[] = [
    {
        id: "AP001",
        sellerId: "S001",
        sellerNickname: "测试卖家1",
        sellerPhone: "13800138001",
        realName: "张三",
        nickname: "测试卖家1",
        videoUrl: "https://example.com/video1.mp4",
        submitTime: "2024-03-15 10:00:00",
        updateTime: "2024-03-15 10:00:00"
    },
    {
        id: "AP002",
        sellerId: "S002",
        sellerNickname: "测试卖家2",
        sellerPhone: "13800138002",
        nickname: "测试卖家2",
        videoUrl: "https://example.com/video2.mp4",
        submitTime: "2024-03-15 09:30:00",
        updateTime: "2024-03-15 09:30:00"
    },
    {
        id: "AP003",
        sellerId: "S003",
        sellerNickname: "测试卖家3",
        sellerPhone: "13800138003",
        nickname: "测试卖家3",
        videoUrl: "https://example.com/video3.mp4",
        submitTime: "2024-03-15 09:00:00",
        updateTime: "2024-03-15 09:00:00"
    }
];

const mockProcessingApprovals: Approval[] = [
    {
        id: "AP004",
        sellerId: "S004",
        sellerNickname: "测试卖家4",
        sellerPhone: "13800138004",
        nickname: "测试卖家4",
        videoUrl: "https://example.com/video4.mp4",
        submitTime: "2024-03-14 16:00:00",
        updateTime: "2024-03-14 16:00:00"
    },
    {
        id: "AP005",
        sellerId: "S005",
        sellerNickname: "测试卖家5",
        sellerPhone: "13800138005",
        nickname: "测试卖家5",
        videoUrl: "https://example.com/video5.mp4",
        submitTime: "2024-03-14 15:30:00",
        updateTime: "2024-03-14 15:30:00"
    }
];

const mockProcessedApprovals: Approval[] = [
    {
        id: "AP006",
        sellerId: "S006",
        sellerNickname: "测试卖家6",
        sellerPhone: "13800138006",
        nickname: "测试卖家6",
        videoUrl: "https://example.com/video6.mp4",
        lastRefuseReason: "视频质量不清晰",
        submitTime: "2024-03-13 14:00:00",
        updateTime: "2024-03-13 16:00:00"
    },
    {
        id: "AP007",
        sellerId: "S007",
        sellerNickname: "测试卖家7",
        sellerPhone: "13800138007",
        nickname: "测试卖家7",
        videoUrl: "https://example.com/video7.mp4",
        submitTime: "2024-03-13 13:00:00",
        updateTime: "2024-03-13 15:00:00"
    }
];

mockData.set("audit_unprocessed", mockUnprocessedApprovals);
mockData.set("audit_processing", mockProcessingApprovals);
mockData.set("audit_processed", mockProcessedApprovals);
mockData.set("superthem_exam_fee", "0"); 